// extracted by mini-css-extract-plugin
module.exports = {"grid":"style__grid__3b6Q+","toggle":"style__toggle__Es8bs","wrapper":"style__wrapper__phJqQ","content":"style__content__AIOFR","button":"style__button__Wbea6"};